import { useTranslation } from 'react-i18next';
import { howItWorksSteps } from '@/mocks/seoContent';

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('howItWorks.title')}
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Prosty proces w pięciu krokach — od wyboru kategorii po odbiór przesyłki w Polsce.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {howItWorksSteps.map((step) => (
            <div key={step.step} className="relative text-center group">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center bg-primary-100 rounded-full mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${step.icon} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <div className="absolute top-7 left-[calc(50%+2rem)] hidden lg:block w-[calc(100%-4rem)] h-px bg-background-200">
                {step.step < 5 && (
                  <div className="absolute top-0 right-0 w-2 h-2 bg-background-300 rounded-full -translate-y-1/2"></div>
                )}
              </div>
              <div className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-accent-500 text-white text-xs font-semibold mb-2">
                {step.step}
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1.5">
                {step.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}